import Posthog from 'posthog-js'

export function getPosthog() {
  const clientKey = import.meta.env.VITE_POSTHOG_CLIENT_KEY
  const isTestmode = window.Cypress || import.meta.env.VITE_APP_IS_IN_E2E === 'true'
  const isDoInit = !isTestmode && !import.meta.env.VITE_APP_ENVIRONMENT === 'staging' && !Posthog.__loaded // Ran out of envs allowance so skipping staging

  if (isDoInit) {
    if (!clientKey) {
      throw new Error('Missing Posthog Client Key!')
    }

    Posthog.init(clientKey, {
      api_host: `${import.meta.env.VITE_EVENTS_PROXY_URL}/metrixhog`,
      persistence: 'memory', // IMPORTANT DO NOT REMOVE THIS LINE!
      person_profiles: 'identified_only', // TODO sanity check
    })
  }

  return Posthog
}
